import React, { useState } from "react";
import Image from "../elements/Image";
import Input from "../form/Input";
import Button from "../form/Button";
import { useSelector } from "react-redux";
import useForm from "../../hooks/useForm";
import useMutation from "../../hooks/useMutation";
import { checkStatus } from "../../services/statusService";
import { statusText } from "../../util/Flag";

const validation = {
  applicationUniqueId: {
    required: true,
    message: "Application No is required",
  },
  email: [
    {
      type: "email",
      required: true,
      message: "Enter valid Email",
    },
  ],
};

const CheckApplicationStatus = ({ setAppStatus }) => {
  const { siteSetting } = useSelector((state) => state.setting);
  const [scholarshipStatus, setScholarshipStatus] = useState({
    status: false,
    data: null,
  });

  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    resetField,
    formValidate,
  } = useForm({
    validationRules: validation,
    initialState: {
      email: "",
      applicationUniqueId: "VFS-",
    },
  });

  const {
    mutate,
    error,
    isPending: isLoading,
  } = useMutation({
    mutationFn: async (val) => {
      return await checkStatus({
        ...val,
      });
    },
    onSuccess: (res) => {
      if (res.status === 200 || res.status === 201) {
        setScholarshipStatus((prev) => ({
          ...prev,
          status: true,
          data: res?.data,
        }));
      } else {
        setScholarshipStatus((prev) => ({
          ...prev,
          status: false,
          data: res?.message,
        }));
      }
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });

  console.log({ scholarshipStatus });

  return (
    <>
      <div className="space-y-10">
        <div className="h-20 mx-auto flex justify-center">
          {siteSetting?.logo?.url ? (
            <Image
              src={siteSetting?.logo?.url}
              alt=""
              effect={"blur"}
              classes={"object-contain"}
            />
          ) : (
            <div className="w-32 h-12 bg-gray-300 animate-pulse" />
          )}
        </div>
        <div className="space-y-6">
          <div className="font-Gotham font-medium text-center">
            Enter details or Log in to check status.
          </div>
          <form onSubmit={(event) => handleSubmit(event, mutate)}>
            <div className="md:flex w-full md:w-auto items-end gap-2 max-w-[100%] md:max-w-xl mx-auto space-y-3">
              <div className="relative w-full md:w-auto flex-shrink flex-grow">
                <Input
                  label={"Enter Email"}
                  labelClasses={"mb-2 !text-gable-green"}
                  inputClasses={
                    "!bg-transparent !rounded-full border-chestnut-rose !h-12 font-Gotham placeholder:!text-chestnut-rose placeholder:!italic"
                  }
                  inputPlaceholder={"Enter Email"}
                  inputName={"email"}
                  value={values?.email}
                  onChange={handleChange}
                  {...formValidate(errors, "email")}
                />
              </div>
              {siteSetting?.scholarShipData && (
                <div className="relative flex-shrink flex-grow">
                  <Input
                    label={"Application Number"}
                    labelClasses={"mb-2 !text-gable-green"}
                    inputClasses={
                      "!bg-transparent !rounded-full border-chestnut-rose !h-12 font-Gotham placeholder:!text-chestnut-rose placeholder:!italic"
                    }
                    inputPlaceholder={"Application Reference"}
                    inputType={"text"}
                    inputName={"applicationUniqueId"}
                    value={values?.applicationUniqueId}
                    onChange={handleChange}
                    {...formValidate(errors, "applicationUniqueId")}
                  />
                </div>
              )}
              <div className="relative flex-shrink-0">
                <Button
                  buttonType="submit"
                  buttonLabel={"Submit"}
                  buttonClasses={"!h-12 !rounded-full !px-6"}
                  isDisable={!siteSetting?.scholarShipData}
                />
              </div>
            </div>
          </form>
          {scholarshipStatus?.data?.status ? (
            <div className="flex flex-col items-center gap-2 text-red-500">
              <div className="flex gap-2">
                <span className="text-base font-semibold">Status:</span>
                <span className="text-sm font-medium mt-1">
                  {`${scholarshipStatus?.data?.status?.title.replace(
                    /_/g,
                    " "
                  )} - ${scholarshipStatus?.data?.status?.description}`}
                </span>
              </div>
            </div>
          ) : (
            <h4 className="text-lg font-bold text-red-500 text-center">
              {scholarshipStatus?.data}
            </h4>
          )}

          {!siteSetting?.scholarShipData && (
            <div className="relative flex-shrink flex-grow">
              <h4 className="text-lg font-bold text-red-500">
                NO SCHOLARSHIPS AVAILABLE RIGHT NOW — CHECK BACK SOON!
              </h4>
            </div>
          )}
        </div>
        <div className="border-t border-shades-04 h-px flex items-center justify-center">
          <span className="inline-flex items-center justify-center w-10 aspect-square bg-white pb-1 font-Gotham text-shades-05">
            or
          </span>
        </div>
        <div className="flex flex-col items-center justify-center">
          <Button
            buttonHasLink={true}
            buttonLink={"/authentication"}
            buttonLabel={"Sign In"}
            buttonClasses={"!h-14 !rounded-full !px-10"}
            buttonLabelClasses={"!text-base sm:!text-lg"}
          />
          <Button
            buttonHasLink={true}
            buttonLink={"/contact"}
            buttonFunction={() => setAppStatus(false)}
            buttonLabel={"Need Help?"}
            buttonClasses={"!h-14 !bg-transparent !px-0 !text-gable-green"}
          />
        </div>
      </div>
    </>
  );
};

export default CheckApplicationStatus;
